/** @jsxImportSource @emotion/react */
import React, { useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import Typography from '@mui/material/Typography'
import { TabsItem } from 'types/tabsItem'
import TabsNavigation from 'components/TabsNavigation'
import * as classes from 'pagesNew/UpgradePage/styles'
import { ExamsList } from '../ExamsList'
import { Config } from '../Config'

const TAB_QUERY_PARAM = 'tab'

const TABS: TabsItem[] = [
  {
    id: 'solutions',
    title: 'Solutions',
  },
  {
    id: 'config',
    title: 'Configuration',
  },
  {
    id: 'statistics',
    title: 'Statistics',
    disabled: true,
  },
]

export const Dashboard = () => {
  const [searchParams, setSearchParams] = useSearchParams()

  const [activeTab, setActiveTab] = useState<TabsItem>(() => {
    const tabId = searchParams.get(TAB_QUERY_PARAM)
    const availableTabs = TABS.filter(({ disabled }) => !disabled)

    return availableTabs.find(({ id }) => id === tabId) || availableTabs[0]
  })

  const handleChangeTab = (activeTab: TabsItem) => {
    setSearchParams((prev) => ({
      ...Object.fromEntries(prev.entries()),
      [TAB_QUERY_PARAM]: activeTab.id,
    }))
    setActiveTab(activeTab)
  }

  const renderActiveTab = () => {
    if (activeTab.id === 'solutions') {
      return <ExamsList />
    }

    if (activeTab.id === 'config') {
      return <Config />
    }

    return null
  }

  return (
    <section css={classes.container}>
      <Typography css={classes.header} variant="title3">
        Plugin
      </Typography>

      <TabsNavigation css={classes.tabs} tabs={TABS} value={activeTab} onChange={handleChangeTab} />

      {renderActiveTab()}
    </section>
  )
}
